import { router } from "@inertiajs/react"
import { SlidersHorizontal } from "lucide-react"

const FILTER_ARRAY_KEYS = [
    "brands",
    "parent_categories",
    "subcategories",
    "calibers",
    "models",
    "conditions",
]

/**
 * Whether any single filter dimension has more than one option selected. A
 * selection that narrows to a single specific anchor (e.g. one brand + one
 * model, or one category + one subcategory) is not a multi-selection — it reads
 * as "watch this exact thing", so the watchlist prompt still applies. Only a
 * genuinely broad selection (two+ brands, two+ calibers, …) counts here. A
 * locked dimension baked into the URL path is not a query filter and is ignored.
 */
export function hasMultipleSelections(activeFilters) {
    if (!activeFilters) {
        return false
    }
    return FILTER_ARRAY_KEYS.some(
        (key) => (activeFilters[key]?.length ?? 0) > 1
    )
}

/**
 * Empty state for a listing with no results. When the user has a broad
 * multi-selection applied it explains the filters matched nothing and offers a
 * one-click clear; otherwise (no filters, or a single specific anchor) it falls
 * back to the provided node (the watchlist prompt).
 */
export default function FilteredListingEmptyState({ activeFilters, fallback }) {
    if (!hasMultipleSelections(activeFilters)) {
        return fallback
    }

    const clearFilters = () => {
        router.get(window.location.pathname, {}, { preserveScroll: true })
    }

    return (
        <div className="flex flex-col items-center justify-center w-full gap-3 px-6 py-10 text-center bg-white border border-gray-300 border-dashed rounded-lg">
            <SlidersHorizontal className="h-6 w-6 text-[#800020]" />
            <div className="flex flex-col gap-1">
                <p className="text-base font-semibold text-gray-900">
                    No active auctions match these filters.
                </p>
                <p className="text-sm text-gray-500">
                    Try adjusting your filter settings or clearing them to see
                    more results.
                </p>
            </div>
            <button
                type="button"
                onClick={clearFilters}
                className="mt-2 rounded-md bg-[#800020] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#651318]"
            >
                Clear Filters
            </button>
        </div>
    )
}
